(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('validatorRequired', validatorRequired);

    function validatorRequired(lodash) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.required = function(modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return false;
                    } else {
                        return true;
                    }
                };

                elm.on('blur', function() {
                    scope.$apply(function () {
                        lodash.set(scope, [
                            'form',
                            attrs.validatorRequired,
                            '$error',
                            'required',
                        ].join('.'), lodash.get(ctrl, '$error.required', false));
                    })
                });
            },
        };
    }
})();